export type GetComponentConversionRulesRequest = {
  envrnmntIdFrom: string;
  envrnmntIdTo: string;
};
